import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {TreeNode} from "primeng/api";
import {CustomerCreditDto} from "../../../model/dto/entity/customer-credit.dto";
import {CustomerCreditAllocationDto} from "../../../model/dto/entity/customer-credit-allocation.dto";
import {ContractPaymentPlannedDto} from "../../../model/dto/entity/contract-payment-planned.dto";
import {CustomerPaymentPlannedDto} from "../../../model/dto/entity/customer-payment-planned.dto";
import {ContractPaymentDto} from "../../../../../feature-crm/cm/model/dto/entity/contract-payment.dto";
import {ContractDto} from "../../../../../feature-crm/cm/model/dto/entity/contract.dto";
import {
    ContractNodeDto,
    ContractPaymentNodeDto,
    ContractPaymentPlannedNodeDto,
    CustomerCreditAllocationNodeDto,
    CustomerCreditNodeDto,
    CustomerPaymentPlannedNodeDto
} from "../../../model/dto/entity/customer-credit-trace.dto";
// import {CustomerCreditNodeDto, NodeDto} from "../../dto/customer-credit-trace.dto";
// NOT_IN_USE
enum CUSTOMERCREDITSTATUS{
    AVAILABLE,
    USED,
    APPLIED,
    PARTIAL
}

enum CUSTOMERCREDITSOURCE{
    OVERPAYMENT,
    ADJUSTMENT,
}
type AllowedClasses =
    CustomerCreditNodeDto |
    CustomerCreditAllocationNodeDto |
    CustomerPaymentPlannedNodeDto |
    ContractPaymentPlannedNodeDto |
    ContractPaymentNodeDto |
    ContractNodeDto;
@Component({
    selector: 'bm-customer-credit-trace',
    templateUrl: 'bm-customer-credit-trace.component.html',
    standalone: false
})
export class BmCustomerCreditTraceComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    customerCredit: TreeNode[];
    rawData: any =  {
        data: {
            customerDtoId: 1,
            customerDtoName: "John Doe",
            creditAmount: 10000,
            currency: "EUR"
        },
        main: true,
        children: [
            {
                data: {
                    billingRunDtoId: 101,
                    billingRunDtoName: "BillingRun Q1",
                    customerDtoId: 1,
                    customerDtoName: "John Doe",
                    customerCreditDtoId: 1,
                    customerCreditDtoName: "Initial Credit",
                    plannedPaymentDtoId: 201,
                    plannedPaymentDtoName: "Planned Payment Jan",
                    allocatedAmount: 5000,
                    currency: "EUR"
                },
                main: true,
                children: [
                    {
                        data: {
                            billingRunDtoId: 102,
                            billingRunDtoName: "BillingRun Q2",
                            customerDtoId: 1,
                            customerDtoName: "John Doe",
                            plannedTypeDtoId: 301,
                            plannedTypeDtoName: "Standard Payment",
                            paymentStatus: "PLANNED",
                            amount: 5000,
                            remainingAmount: 2000,
                            currency: "EUR"
                        },
                        main: true,
                        children: [
                            {
                                data: {
                                    contractDtoId: 401,
                                    contractDtoName: "Contract Alpha",
                                    startDate: "2025-01-01",
                                    endDate: "2025-12-31",
                                    dueDate: "2025-03-31",
                                    plannedTypeDtoId: 501,
                                    plannedTypeDtoName: "Installment",
                                    status: "DUE",
                                    amount: 3000,
                                    remainingAmount: 1000,
                                    currency: "EUR"
                                },
                                main: true,
                                children: [
                                    {
                                        data: {
                                            contractDtoId: 402,
                                            contractDtoName: "Contract Alpha",
                                            startDate: "2025-01-01",
                                            firstPaymentDate: "2025-01-15",
                                            payFrequencyDtoId: 601,
                                            payFrequencyDtoName: "Monthly",
                                            paymentTypeDtoId: 701,
                                            paymentTypeDtoName: "SEPA",
                                            paymentMomentDtoId: 801,
                                            paymentMomentDtoName: "End of Month"
                                        },
                                        main: true,
                                        children: [
                                            {
                                                data: {
                                                    contractDtoId: 403,
                                                    contractDtoName: "Contract Alpha",
                                                    startDate: "2025-01-01",
                                                    firstPaymentDate: "2025-01-15",
                                                    payFrequencyDtoId: 601,
                                                    payFrequencyDtoName: "Monthly",
                                                    paymentTypeDtoId: 701,
                                                    paymentTypeDtoName: "SEPA",
                                                    paymentMomentDtoId: 801,
                                                    paymentMomentDtoName: "End of Month"
                                                },
                                                main: true,
                                                children: []
                                            }
                                        ]
                                    },
                                    {
                                        data: {
                                            contractDtoId: 401,
                                            contractDtoName: "Contract Alpha",
                                            startDate: "2025-01-01",
                                            firstPaymentDate: "2025-01-15",
                                            payFrequencyDtoId: 601,
                                            payFrequencyDtoName: "Monthly",
                                            paymentTypeDtoId: 701,
                                            paymentTypeDtoName: "SEPA",
                                            paymentMomentDtoId: 801,
                                            paymentMomentDtoName: "End of Month"
                                        },
                                        main: true,
                                        children: [
                                            {
                                                data: {
                                                    contractDtoId: 404,
                                                    contractDtoName: "Contract Alpha",
                                                    startDate: "2025-01-01",
                                                    firstPaymentDate: "2025-01-15",
                                                    payFrequencyDtoId: 601,
                                                    payFrequencyDtoName: "Monthly",
                                                    paymentTypeDtoId: 701,
                                                    paymentTypeDtoName: "SEPA",
                                                    paymentMomentDtoId: 801,
                                                    paymentMomentDtoName: "End of Month"
                                                },
                                                main: true,
                                                children: []
                                            }
                                        ]

                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        const creditTrace = [this.convertToTreeNode(this.rawData)];
        this.customerCredit = [...creditTrace];
        console.log(this.customerCredit);
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }


    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    NodeLabelMap = new Map<Function, { label: string; type: string, icon: string }>([
        [CustomerCreditDto, { label: 'Customer Credit', type: 'CustomerCredit', icon: 'pi pi-wallet' }],
        [CustomerCreditAllocationDto, { label: 'Credit Allocation', type: 'CustomerCreditAllocation', icon: 'pi pi-link'  }],
        [CustomerPaymentPlannedDto, { label: 'Payment Planned', type: 'CustomerPaymentPlanned', icon: 'pi pi-credit-card'  }],
        [ContractPaymentPlannedDto, { label: 'Contract Payment Planned', type: 'ContractPaymentPlanned', icon: 'pi pi-link'  }],
        [ContractPaymentDto, { label: 'Contract Payment', type: 'ContractPayment', icon: 'pi pi-bullseye'  }],
        [ContractDto, { label: 'Contract', type: 'Contract', icon: 'pi pi-file'  }],
    ]);



    convertToTreeNode<T extends AllowedClasses>(node: T): TreeNode {

        return {
            data: { ...node.data, main: node.main }, // preserve main flag
            expanded: true,
            children: node.children?.map(child => this.convertToTreeNode<T>(child)) ?? []
        };
    }

    protected readonly CUSTOMERCREDITSOURCE = CUSTOMERCREDITSOURCE;
    protected readonly CUSTOMERCREDITSTATUS = CUSTOMERCREDITSTATUS;
}
